/********************************************************************************
 * Copyright (c) 2020 Cedalo AG
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import HelpIcon from '@material-ui/icons/Help';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export default function HelpButton() {
	const onHelp = () => {
		window.open('https://docs.cedalo.com/streamsheets/introduction/', '_blank');
	};
	return (
		<Tooltip enterDelay={300} title={<FormattedMessage id="Tooltip.Help" defaultMessage="Help" />}>
			<div>
				<IconButton onClick={onHelp}>
					<HelpIcon style={{ color: 'white' }} />
				</IconButton>
			</div>
		</Tooltip>
	);
}



// WEBPACK FOOTER //
// ./src/layouts/HelpButton.js